import axios from 'axios';
import AIReview from '@/models/aiReview';
import { applyErrorHandlers } from '@/decorators/applyErrorHandler';

const API_AI_REVIEW_URL = process.env.VUE_APP_API_URL + '/ai_reviews';

// Teacher-facing AI submission-review actions. Regular axios: the shared instance
// carries the auth header. applyErrorHandlers wraps every public static so reject
// paths normalise error.message (specs assert `.rejects.toBeTruthy()`).
export default class AIReviewController {
  // Load the review for a submission, or null when none exists (backend 404).
  static async getBySubmission(submissionId) {
    try {
      const response = await axios.get(`${API_AI_REVIEW_URL}/by_submission/${submissionId}`);
      return new AIReview(response.data);
    } catch (e) {
      if (e.response && e.response.status === 404) return null;
      throw e;
    }
  }

  // Generate (or regenerate) a review for a submission; optional custom prompt.
  static async generate(submissionId, aiPrompt = null) {
    const payload = { submission_id: submissionId };
    if (aiPrompt) payload.ai_prompt = aiPrompt;
    const response = await axios.post(`${API_AI_REVIEW_URL}/generate`, payload);
    return new AIReview(response.data);
  }

  // Approve the review for a submission (teacher-only).
  static async approve(submissionId) {
    const response = await axios.post(`${API_AI_REVIEW_URL}/${submissionId}/approve`);
    return new AIReview(response.data);
  }

  // Revoke a previous approval (teacher-only).
  static async revoke(submissionId) {
    const response = await axios.post(`${API_AI_REVIEW_URL}/${submissionId}/revoke`);
    return new AIReview(response.data);
  }
}

applyErrorHandlers(AIReviewController);
